import { Component, OnInit } from '@angular/core';
import { CArticle } from '../../../models/article.models/article.model';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { ArticleService } from '../../../services/article.service';
import { CArticleSearchModel } from '../../../models/article.models/articleSearchModel.model';
import { CBlog } from '../../../models/blog.models/blog.model';
import { BlogService } from '../../../services/blog.service';
import { CBlogSearchModel } from '../../../models/blog.models/blogSearchModel.model';
import { CCompanyInfoViewModel } from '../../../models/commonInformation.models/commonInformation.model';
import { CommonInformationService } from '../../../services/commonInformation.service';
import { CCommonPage } from '../../../models/page.models/commonPage.model';
import { CommonPageService } from '../../../services/commonPage.service';
import { Title, Meta } from '@angular/platform-browser';
import { themservice } from '../../../services/them.service';
import { CCompanyEquipment } from 'src/app/models/galery.models/companyEquipment.model';
import { CompanyEquipmentService } from 'src/app/services/companyEquipment.service';
import { CFAQ } from 'src/app/models/faq.models/faq.model';
import { FAQService } from 'src/app/services/faq.service';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit {
   
    ngOnInit(): void {
        this.GetCommonPage();
        this.GetCommonInfo();
        this.GetArticleArray();
        this.GetBlogArray();
        this.GetFAQArray();
        this.GetCompanyEquipmentArray();
    }

    commonPage: CCommonPage = new CCommonPage();
    id: string = 'HomeIndex';
    commonInformation: CCompanyInfoViewModel = new CCompanyInfoViewModel();
    articleArray: CArticle[] = [];
    companyEquipmentArray: CCompanyEquipment[] = [];
    blogArray: CBlog[] = [];
    faqArray: CFAQ[] = [];
    ApiServiceAddress: string;

    constructor(private commonPageService: CommonPageService,private faqService: FAQService, private commonInformationService: CommonInformationService,private companyEquipmentService: CompanyEquipmentService,
        private articleService: ArticleService,private themservice: themservice, private blogService: BlogService, private titleService: Title, private metaService: Meta) {

        this.ApiServiceAddress = API_ServerAddress;
    }

    SetPageMetaData(model: CCommonPage) {
        this.titleService.setTitle(model.fMetaTitle);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }

    GetCommonPage() {
        this.commonPageService.GetById(this.id)
            .subscribe((data: CCommonPage) => {
                this.commonPage = data;
                this.SetPageMetaData(data);
            });
    }
    GetFAQArray() {
        this.faqService.GetList().subscribe((data: CFAQ[]) => this.faqArray = data);
    }
    GetCommonInfo() {
        this.commonInformationService.GetInfo()
            .subscribe((data: CCompanyInfoViewModel) => this.commonInformation = data);
    }
    GetCompanyEquipmentArray() {
        this.companyEquipmentService.GetList().subscribe((data: CCompanyEquipment[]) => this.companyEquipmentArray = data);
    }
    GetArticleArray() {
        let searchModel: CArticleSearchModel = new CArticleSearchModel();
        searchModel.OrderByDESC = 'fId';
        searchModel.Fetch = 4;
        searchModel.Offset = 0;

        this.articleService.GetList(searchModel).subscribe((data: CArticle[]) => this.articleArray = data);
    }

    GetBlogArray() {
        let searchModel: CBlogSearchModel = new CBlogSearchModel();
        searchModel.OrderByDESC = 'fId';
        searchModel.Fetch = 4;
        searchModel.Offset = 0;

        this.blogService.GetList(searchModel).subscribe((data: CBlog[]) => this.blogArray = data);
    }

    MakeShortDescription(input : string){
        return input.substring(0, 250) + " . . . ";
    }
}